import {Routes,RouterModule} from '@angular/router'
import { NgModule } from '@angular/core'
import { ManualdatasettingsComponent } from './manualdatasettings.component'



const routes:Routes = [
    {
        path:'',
        component:ManualdatasettingsComponent
    },
];

@NgModule(
    {
        imports:[RouterModule.forChild(routes)],
        exports: [RouterModule]
    }
)

export class manualdatasettingsRoutingModule{}